<div fxLayout="column" class="login-form">

  <img src="/assets/images/mxa_logo.svg" width="368" alt="METADVISOR" draggable="false" fxHide.lt-md  *hideBlank="false">
  <img src="/assets/images/metadvisor_logo_black.svg" alt="METADVISOR" width="250"  fxHide.lt-md  *hideBlank="true">

  @if (loading) {
    <metadv-loader></metadv-loader>
  }
  @if (!loading && errorString) {
    <div fxLayout="column" class="login-form">
      <span class="title1">Errore</span>
      <span class="subtitle1" fxFlexOffset="20px">{{ errorString }}</span>
      <button mat-flat-button color="primary" fxFlexOffset="30px" routerLink="/login">Torna al login</button>
    </div>
  }

</div>
